export default __webpack_public_path__ + "static/media/newcolorabout.2a0a5158.png";